import { supabase } from '../supabase/client';

export const signInWithOTP = async email => {
  const { error } = await supabase.auth.signInWithOtp({
    email,
  });

  if (error) {
    throw error;
  }
};

export const verifyOTP = async (email, token) => {
  const { error } = await supabase.auth.verifyOtp({
    email,
    token,
    type: 'email',
  });

  if (error) {
    throw error;
  }
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) {
    throw error;
  }
};

export const getCurrentUser = async () => {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return session?.user;
};
